import { render, staticRenderFns } from "./Stocks_mobile.vue?vue&type=template&id=6fbf5d96&scoped=true&"
import script from "./Stocks_mobile.vue?vue&type=script&lang=js&"
export * from "./Stocks_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Stocks_mobile.vue?vue&type=style&index=0&id=6fbf5d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf5d96",
  null
  
)

export default component.exports